import React from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap5/Form';

import {
  ErrorMessage,
  useField,
} from 'formik';

export default function HorizontalSelectButtonsField(props) {
  const {
    name, label, collection, hint, required, onClick, wrapperClassName, containerClassName, optionClassName,
  } = props;

  const [field, , helpers] = useField(props);
  const { setValue } = helpers;

  const onItemClick = (value, e) => {
    if (field.value !== value) {
      setValue(value);
      if (onClick !== undefined) {
        onClick(value, e);
      }
    }
  };

  return (
    <Form.Group className={wrapperClassName} controlId="formBasicEmail">
      {label && (
        <Form.Label>
          <>
            {label}
            {required && <abbr className="ms-1" title="required">*</abbr>}
          </>
        </Form.Label>
      )}

      <div className={containerClassName}>
        {collection.map((item) => (
          <Form.Check
            key={item.value}
            type="radio"
            name={field.name}
            id={`${field.name}-${item.value}`}
            label={item.label}
            className={`form-check-buttons ${optionClassName}`}
            defaultChecked={field.value !== undefined && field.value === item.value}
            disabled={item.disable}
            onClick={(e) => onItemClick(item.value, e)}
          />
        ))}
      </div>

      {hint && <Form.Text className="text-muted">{hint}</Form.Text>}

      <ErrorMessage
        name={name}
        render={(msg) => <Form.Control.Feedback type="invalid">{msg}</Form.Control.Feedback>}
      />
    </Form.Group>
  );
}

HorizontalSelectButtonsField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  collection: PropTypes.arrayOf(PropTypes.object).isRequired,
  hint: PropTypes.string,
  required: PropTypes.bool,
  onClick: PropTypes.func,
  wrapperClassName: PropTypes.string,
  containerClassName: PropTypes.string,
  optionClassName: PropTypes.string,
};

HorizontalSelectButtonsField.defaultProps = {
  hint: '',
  required: false,
  onClick: () => {},
  wrapperClassName: 'mb-3',
  containerClassName: 'text-center',
  optionClassName: '',
};
